function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}import "./tracked.scss";
import template from "./tracked.html";

export var TrackedComponent = {
  template: template,
  bindings: {
    current: "<",
    cals: "<",
    left: "<",
    viewTitle: "@" },

  controller: ["LayoutService",
  function TrackedComponentController(LayoutService) {
    "ngInject";_classCallCheck(this, TrackedComponentController);
    this.LayoutService = LayoutService;
    console.log(this);
  }] };